import { render, staticRenderFns } from "./Productdetails.vue?vue&type=template&id=1b8aac3e&scoped=true&"
import script from "./Productdetails.vue?vue&type=script&lang=js&"
export * from "./Productdetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8aac3e",
  null
  
)

export default component.exports